const randomEmail = () => {
  const email = $('.js-dev-populate-email').data('email') || 'hive-webshop-qa@purepoint.io';
  const emailSegments = email.split('@');
  const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  return [emailSegments[0], '+', s4(), s4(), s4(), s4(), s4(), '@', emailSegments[1]].join('');
};

export default randomEmail;
